"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberingListIndexConstants = void 0;
var constants_1 = require("@devexpress/utils/lib/constants");
var numbering_list_1 = require("../../model/numbering-lists/numbering-list");
var NumberingListIndexConstants = (function () {
    function NumberingListIndexConstants() {
    }
    NumberingListIndexConstants.noNumberingList = numbering_list_1.NumberingList.NoNumberingListIndex;
    NumberingListIndexConstants.listIndexNotSetted = numbering_list_1.NumberingList.NumberingListNotSettedIndex;
    NumberingListIndexConstants.minValue = 0;
    NumberingListIndexConstants.maxValue = constants_1.Constants.MAX_SAFE_INTEGER;
    return NumberingListIndexConstants;
}());
exports.NumberingListIndexConstants = NumberingListIndexConstants;
